import { getCurrentParticipant } from "@/features/participants/api/get-current-participant";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import socketClient from "@/lib/socket-io";

export function raiseHand() {
  const participantId = getCurrentParticipant()?.participantId;
  if (!participantId) {
    throw new Error("Participant ID not found");
  }
  useVidyoStore.getState().participants.toggleCurrentParticipantHand();
  socketClient.emit("raiseHand", { participantId });
}

export function lowerHand() {
  const participantId = getCurrentParticipant()?.participantId;
  if (!participantId) {
    throw new Error("Participant ID not found");
  }
  useVidyoStore.getState().participants.toggleCurrentParticipantHand();

  socketClient.emit("lowerHand", { participantId });
}
